import { IRecurringTaskForm } from '../../types';

export const recurringReducer = (
    task: IRecurringTaskForm,
    update: IRecurringTaskForm
): IRecurringTaskForm => ({
    ...task,
    ...update
})
